import script from "./reSend.vue?vue&type=script&setup=true&lang=js"
export * from "./reSend.vue?vue&type=script&setup=true&lang=js"

import "./reSend.vue?vue&type=style&index=0&id=74de9529&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74de9529"]])

export default __exports__